import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

const WhaleRadarLanding = () => {
  const [caInput, setCaInput] = useState("");
  const history = useHistory();

  // 🛡️ DYNAMIC SEO & TITLE LOGIC
  useEffect(() => {
    document.title = "Whale Radar Bot | Solana Institutional Data";
    return () => {
      document.title = "Crypto Lakeside | Institutional Trading Terminal";
    };
  }, []);

  const tgLink = "https://telegram.me/bitcoinblockchain501";

  const handleCheckRadar = () => {
    const input = caInput.trim() || "unc";
    // Using internal history push instead of window.open to keep the app fast
    history.push(`/demo?ca=${input}&utm_source=whaleradar&utm_medium=landing&utm_campaign=demo`);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handleCheckRadar();
  };

  return (
    <div style={{ backgroundColor: "#0A0F1C", minHeight: "100vh", color: "white", fontFamily: "system-ui, sans-serif" }}>
      {/* WHATSAPP KILL SWITCH */}
      <style>{`a[href*="wa.me"], div[class*="whatsapp"] { display: none !important; }`}</style>
      
      <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "48px 24px" }}>
        
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "48px" }}>
          <h1 style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
            LAKESIDE <span style={{ color: "#FACC15" }}>NODES</span>
          </h1>
          <button 
            onClick={() => history.push('/demo?ca=unc')}
            style={{ backgroundColor: "#FACC15", color: "black", padding: "12px 24px", borderRadius: "16px", fontWeight: "600", border: "none", cursor: "pointer" }}
          >
            View Live Demo
          </button>
        </div>

        {/* Hero Section */}
        <div style={{ textAlign: "center", marginBottom: "64px" }}>
          <h2 style={{ fontSize: "clamp(40px, 8vw, 70px)", fontWeight: "bold", lineHeight: "1.1", marginBottom: "24px" }}>
            Real-Time <span style={{ background: "linear-gradient(90deg, #FACC15, #FDE047)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>Whale Radar Bot</span><br />
            for Solana
          </h2>
          <p style={{ fontSize: "20px", color: "#94a3b8", maxWidth: "700px", margin: "0 auto 48px" }}>
            See institutional buys, whale accumulation, and liquidity flow before it hits the chart.
          </p>

          {/* Input Box */}
          <div style={{ backgroundColor: "#111827", border: "1px solid #374151", borderRadius: "24px", padding: "32px", maxWidth: "600px", margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: "24px" }}>
              <p style={{ color: "#34d399", fontWeight: "500", margin: "0 0 8px 0" }}>Currently Free Monitoring</p>
              <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>$UNC • $PEACE</p>
            </div>
            
            <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
              <input 
                type="text" 
                placeholder="Enter CA or alias (e.g. unc)" 
                value={caInput}
                onChange={(e) => setCaInput(e.target.value)}
                onKeyPress={handleKeyPress}
                style={{ flex: 1, backgroundColor: "black", border: "1px solid #4b5563", borderRadius: "16px", padding: "18px 24px", color: "white", fontSize: "18px", outline: "none" }}
              />
              <button 
                onClick={handleCheckRadar}
                style={{ backgroundColor: "#FACC15", color: "black", fontWeight: "bold", padding: "18px 32px", borderRadius: "16px", border: "none", cursor: "pointer", fontSize: "18px" }}
              >
                Check Radar
              </button>
            </div>
          </div>
        </div>

        {/* Features Grid */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "24px", marginBottom: "64px" }}>
          <div style={{ backgroundColor: "rgba(17, 24, 39, 0.7)", border: "1px solid #374151", borderRadius: "24px", padding: "32px", textAlign: "center" }}>
            <div style={{ fontSize: "32px", color: "#FACC15", marginBottom: "16px" }}>⚡</div>
            <h3 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "8px" }}>Live Whale Tape</h3>
            <p style={{ color: "#94a3b8", margin: 0 }}>Buys & sells over $2,000 in real-time</p>
          </div>
          <div style={{ backgroundColor: "rgba(17, 24, 39, 0.7)", border: "1px solid #374151", borderRadius: "24px", padding: "32px", textAlign: "center" }}>
            <div style={{ fontSize: "32px", color: "#60a5fa", marginBottom: "16px" }}>🐋</div>
            <h3 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "8px" }}>Institutional Flow</h3>
            <p style={{ color: "#94a3b8", margin: 0 }}>Track smart money accumulation</p>
          </div>
          <div style={{ backgroundColor: "rgba(17, 24, 39, 0.7)", border: "1px solid #374151", borderRadius: "24px", padding: "32px", textAlign: "center" }}>
            <div style={{ fontSize: "32px", color: "#34d399", marginBottom: "16px" }}>📊</div>
            <h3 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: "8px" }}>Fear & Greed</h3>
            <p style={{ color: "#94a3b8", margin: 0 }}>Per token sentiment index</p>
          </div>
        </div>

        {/* 1 SOL Offer Box */}
        <div style={{ background: "linear-gradient(135deg, rgba(250, 204, 21, 0.1) 0%, transparent 100%)", border: "1px solid rgba(250, 204, 21, 0.3)", borderRadius: "32px", padding: "48px", textAlign: "center" }}>
          <div style={{ display: "inline-block", backgroundColor: "black", color: "#FACC15", fontSize: "56px", fontWeight: "bold", padding: "12px 32px", borderRadius: "20px", marginBottom: "24px" }}>
            1 SOL
          </div>
          <h3 style={{ fontSize: "30px", fontWeight: "bold", marginBottom: "16px" }}>Lifetime Access License</h3>
          <ul style={{ textAlign: "left", maxWidth: "400px", margin: "0 auto 40px", listStyle: "none", padding: 0, color: "#d1d5db", lineHeight: "2" }}>
            <li>✅ Dedicated Institutional Node</li>
            <li>✅ Custom Telegram Whale Bot</li>
            <li>✅ Full React Source Code</li>
            <li>✅ Priority Support & Updates</li>
          </ul>
          <a 
            href={tgLink} 
            target="_blank" 
            rel="noreferrer"
            style={{ display: "inline-block", backgroundColor: "#FACC15", color: "black", fontWeight: "bold", fontSize: "20px", padding: "24px 48px", borderRadius: "20px", textDecoration: "none" }}
          >
            Order on Telegram →
          </a>
        </div>

      </div>
    </div>
  );
};

export default WhaleRadarLanding;
